import moment from 'moment-timezone';
import * as dateutils from './DateTimeUtils.js'
import store from './vuex/store.js';

export default class AppointmentUtils {
    
    constructor(appointment) { 
        this.appointment = appointment
        this.isAppointmentPending = appointment.status === 0
        this.isAppointmentApproved = appointment.status === 1
        this.isAppointmentComplete = appointment.status === 4
        this.isAppointmentRejected = appointment.status === 2
        this.isAppointmentCancelled = appointment.status === 3        
        this.isOnline = appointment.type === 'online'
        this.isPaidOnline = appointment.bill.payment_mode === 1
        this.config = store.getters.config
        
        var end = dateutils.utcToLocal(this.appointment.end_time)
        var now = moment()

        this.isPast = now.isAfter(end);
        end.add(24,'hours')
        this.is24HoursPassedAfterEndTime = now.isAfter(end);

        if(this.isOnline){
            this.didDoctorJoin = this.checkDidDoctorJoin()
            this.didPatientJoin = this.checkDidPatientJoin()
        }        
     }

     getCallDurationBetweenUsers(){
        var total_duration_mins = 0
        try{
            var doctor_join_arr =[]
            var patient_join_arr = []
            
            this.appointment.call_logs.forEach(log => {
                if(log.type === "join"){
                    if(log.record_type === "Doctor")
                        doctor_join_arr.push(log)
                    else if(log.record_type === "Patient")
                        patient_join_arr.push(log)                                            
                }
                else if(log.type === "left"){
                    
                    var isSessionActive = false
                    if(doctor_join_arr.length > 0 && patient_join_arr.length > 0){
                        isSessionActive = true
                    }                                                                        
                    
                    if(isSessionActive){
                        if(log.record_type === "Doctor" && doctor_join_arr.length == 1 || 
                           log.record_type === "Patient" && patient_join_arr.length == 1){
                            var start;
                            if(patient_join_arr[0].timestamp > doctor_join_arr[0].timestamp)
                                start = dateutils.utcToLocal(patient_join_arr[0].timestamp)
                            else
                                start = dateutils.utcToLocal(doctor_join_arr[0].timestamp)
                            var end = dateutils.utcToLocal(log.timestamp)
                            var duration_mins = Math.abs(moment.duration(start.diff(end)).asMinutes())
                            total_duration_mins += duration_mins
                            if(log.record_type === "Doctor")
                                doctor_join_arr.pop(log)
                            else if(log.record_type === "Patient")
                                patient_join_arr.pop(log)       
                        }                        
                    }
                }

                return true;
            });

            if(doctor_join_arr.length > 0 && patient_join_arr.length > 0){
                var start;
                if(patient_join_arr[0].timestamp > doctor_join_arr[0].timestamp)
                    start = dateutils.utcToLocal(patient_join_arr[0].timestamp)
                else
                    start = dateutils.utcToLocal(doctor_join_arr[0].timestamp)
                    
                var end = dateutils.utcToLocal(this.appointment.end_time)
                
                var duration_mins = Math.abs(moment.duration(start.diff(end)).asMinutes())
                total_duration_mins += duration_mins
            }
            return total_duration_mins;
        }
        catch(e){
            return total_duration_mins;
        }
        
    }

    checkIsMinCallDurationAchievedBetweenUsers(){
        var duration_mins = this.getCallDurationBetweenUsers()

        var start = dateutils.utcToLocal(this.appointment.start_time)
        var end = dateutils.utcToLocal(this.appointment.end_time)
                
        var total_mins= Math.abs(moment.duration(start.diff(end)).asMinutes())
        if(duration_mins > total_mins)
            duration_mins = total_mins
        
        var duration_percent = (duration_mins/total_mins) * 100
        if(duration_percent >= this.config.appointment_config.min_call_duration_between_users)
            return true
        else
            return false
    }

    checkDidDoctorJoin(){
        var isJoined = false
        try{
            this.appointment.call_logs.every(function(log) {
                if(log.type === "join" && log.record_type === "Doctor"){
                    isJoined = true;
                    return false;
                }
                else
                    return true
            });
            return isJoined    
        }
        catch(e){
            return isJoined    
        }                
        
    }

    checkDidPatientJoin(){
        var isJoined = false
        try{
            this.appointment.call_logs.every(function(log) {
                if(log.type === "join" && log.record_type === "Patient"){
                    isJoined = true;
                    return false;
                }
                else
                    return true
            });
            return isJoined
        }
        catch(e){
            return isJoined
        }
        
    }

    isPastAppointment() {
        var end = dateutils.utcToLocal(this.appointment.end_time)
        return end.isBefore(moment());
    }

    canCancel() {   
                        
        
        var end = dateutils.utcToLocal(this.appointment.end_time)
        var stopShowingCancelAtTime = end.clone()
        stopShowingCancelAtTime.add(this.config.appointment_config.show_max_cancel_duration,'minutes')
        var isCrossedCancelDuration = moment().isAfter(stopShowingCancelAtTime)
        if(this.isOnline){
            var onlineCancelConditions = !this.didDoctorJoin && this.didPatientJoin ||
                                         !this.didDoctorJoin && !this.didPatientJoin;                    
            
            return (this.isAppointmentPending || this.isAppointmentApproved)  && onlineCancelConditions && !isCrossedCancelDuration;
        }
        else
            return (this.isAppointmentPending || this.isAppointmentApproved) && !isCrossedCancelDuration;
    }
    

    canVideoCall() {                  
        var show_video_btn_buffer_mins_before = this.config.appointment_config.show_button_before_duration
        var show_video_btn_buffer_mins_after = this.config.appointment_config.show_button_after_duration
        var start = dateutils.utcToLocal(this.appointment.start_time).subtract(show_video_btn_buffer_mins_before,'minutes')
        var end = dateutils.utcToLocal(this.appointment.end_time).add(show_video_btn_buffer_mins_after, 'minutes')
        var now = moment()        
        var is_show_button_time_available = now.isBetween(start,end)        
        // var is_show_button_time_available = now.isAfter(start)        
        return this.isOnline && this.isAppointmentApproved && is_show_button_time_available

    }

     
    canReschedule() {    
        var rescheduleConditions = this.didDoctorJoin && !this.didPatientJoin ||
                                         !this.didDoctorJoin && this.didPatientJoin ||
                                         !this.didDoctorJoin && !this.didPatientJoin ||
                                         this.didDoctorJoin && this.didPatientJoin && !this.checkIsMinCallDurationAchievedBetweenUsers()

        if(this.isOnline)
            return (this.isAppointmentApproved || this.isAppointmentPending) && !this.isAppointmentComplete && rescheduleConditions;
        else
            return (this.isAppointmentApproved || this.isAppointmentPending) && !this.isAppointmentComplete;

    }

    canMarkAsComplete() {    
        
        if(this.isOnline){            
            return this.isAppointmentApproved && this.didDoctorJoin && this.didPatientJoin;
        }
        else        
            return (this.isAppointmentApproved && this.isPast) || (this.is24HoursPassedAfterEndTime && this.isAppointmentPending);
    }

    canGiveFeedback() {
        return this.isAppointmentComplete
    }

    canRaiseTicket() {
        var end = dateutils.utcToLocal(this.appointment.end_time)        
        var isAppointmentInPast = moment().isAfter(end)
        return isAppointmentInPast && this.isPaidOnline
    }

  }
